import React, { useEffect, useState } from 'react';
import { BasicTheme } from 'react-design-components';
import { SentryInit, useConfig, Loader, Loading } from 'react-commons';
import { Entrypoint } from './components/Entrypoint';
import { TagManager } from '@mineko/react-gtm-promisified';
import { initClient, runQueryV2 } from 'react-commons/utils/graphql';

import { UserProfile } from './gql';

import preload from './gql/preload';
import { UserProfile as UserProfileType } from './types/UserProfile';
import { UserContext } from '../react-commons/context/userContext';

const queryUserProfile = (cookieName: string, clientName: string) =>
  runQueryV2({ query: UserProfile, httpMethod: 'POST', cookieName, clientName, skipRedirectOnUnauthorized: true }).then(
    (res: any) => res?.Profile,
  );

const App: React.FC = () => {
  const config = useConfig();
  const [ready, setReady] = useState(false);
  const [userProfile, setUserProfile] = useState<UserProfileType | null>(null);

  useEffect(() => {
    if (config) {
      console.log(`Config loaded: ${config.APP.REACT_APP_ENV}`);
      const {
        REACT_APP_SENTRY_DSN_ORDER,
        REACT_APP_GTM_ID,
        REACT_APP_GTM_PREVIEW,
        REACT_APP_GTM_AUTH,
        REACT_APP_USER_PROFILE_API_URL,
        REACT_APP_ORDER_API_URL,
        REACT_APP_CSRF_COOKIE_NAME,
      } = config.APP;

      REACT_APP_SENTRY_DSN_ORDER &&
        SentryInit({
          dsn: REACT_APP_SENTRY_DSN_ORDER,
          release: window['VERSION'],
          environment: config.APP_ENV,
        });
      REACT_APP_GTM_ID &&
        TagManager.init({
          containerId: REACT_APP_GTM_ID,
          preview: REACT_APP_GTM_PREVIEW,
          auth: REACT_APP_GTM_AUTH,
        });

      initClient([
        {
          name: 'default',
          url: REACT_APP_ORDER_API_URL,
        },
        {
          name: 'userProfile',
          url: REACT_APP_USER_PROFILE_API_URL,
        },
      ]);

      if (!userProfile) {
        queryUserProfile(REACT_APP_CSRF_COOKIE_NAME, 'userProfile').then(setUserProfile).catch(console.error);
      }

      preload();
      setReady(true);
    }
  }, [config]);

  return (
    <BasicTheme>
      <UserContext.Provider value={userProfile}>
        <Loader>{ready ? <Entrypoint defaultRoute={config.ENV.DEFAULT_URL} /> : <Loading />}</Loader>
      </UserContext.Provider>
    </BasicTheme>
  );
};

export default App;
